/* ============================================================
   OSZEA — Shipping & Tracking + Returns & Exchanges sections
   Powers BOTH oszea-shipping.liquid and oszea-returns.liquid.
   Vanilla JS, dependency-free, Shopify Theme-Editor friendly.

   • Everything is scoped to the section root (.oszea-sp) and
     re-binds on `shopify:section:load`, so it stays live while
     editing in the Theme Editor.
   • Shared chrome (nav / footer / mobile menu) is the THEME's
     responsibility — this file only powers the section body.
   • The tracking RESULT and returns NEXT-STEPS are front-end
     demos for design. Wire them to your real apps via the
     section's "Integrations" settings (data-track-url /
     data-returns-url) and the DEVELOPER notes below.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__oszeaSpBound) return;
    root.__oszeaSpBound = true;

    var $  = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* ---------- Config (from Theme-Editor settings via data-attrs) ---------- */
    var cfg = {
      trackUrl:   root.getAttribute('data-track-url')   || '',
      returnsUrl: root.getAttribute('data-returns-url') || ''
    };
    function buildUrl(tpl, data) {
      if (!tpl) return '#';
      return tpl.replace(/\{(\w+)\}/g, function (_, k) { return encodeURIComponent(data[k] || ''); });
    }
    function emailOk(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((v || '').trim()); }
    function validField(el, ok) { var f = el.closest('.cf-field'); if (f) f.classList.toggle('invalid', !ok); return ok; }

    /* ---------- Scroll reveal (position-based — robust everywhere) ---------- */
    root.classList.add('ct-ready');
    var revealEls = $$('.reveal');
    function revealCheck() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      revealEls = revealEls.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) { el.classList.add('in'); return false; }
        return true;
      });
    }
    revealCheck();
    requestAnimationFrame(revealCheck);
    window.addEventListener('scroll', revealCheck, { passive: true });
    window.addEventListener('resize', revealCheck, { passive: true });
    window.addEventListener('load', revealCheck);

    /* ---------- Smooth scroll + optional focus ---------- */
    function scrollToEl(target, offset) {
      if (!target) return;
      var y = target.getBoundingClientRect().top + window.scrollY - (offset || 90);
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }
    $$('[data-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var t = $(href); if (!t) return;
        e.preventDefault(); scrollToEl(t);
        var focusSel = a.getAttribute('data-focus');
        if (focusSel) setTimeout(function () { var n = $(focusSel); if (n) n.focus({ preventScroll: true }); }, reduce ? 0 : 650);
      });
    });

    /* clear invalid on input across all lookup / returns fields */
    $$('.cf-input, .cf-select, .cf-textarea').forEach(function (el) {
      var clear = function () { var f = el.closest('.cf-field'); if (f) f.classList.remove('invalid'); };
      el.addEventListener('input', clear); el.addEventListener('change', clear);
    });

    /* ============================================================
       TRACKING LOOKUP (inline) — shipping section
       Demo result data for design; swap for real fulfilment data.
       ============================================================ */
    var trackForm = $('#trackLookupForm');
    if (trackForm) {
      var tEmpty = $('#trackEmpty'), tError = $('#trackError'), tResult = $('#trackResult'), tFormBox = $('#trackFormBox');
      trackForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var order = $('#tkOrder'), email = $('#tkEmail'), ok = true;
        ok = validField(order, !!order.value.trim()) && ok;
        ok = validField(email, emailOk(email.value)) && ok;
        if (tError) tError.classList.remove('show');
        if (!ok) return;
        var btn = $('.ohub-submit', trackForm); if (btn) btn.classList.add('loading');
        setTimeout(function () {
          if (btn) btn.classList.remove('loading');
          var ov = order.value.trim();
          /* demo "no match" trigger so the error state is visible in design */
          if (/0000$/.test(ov.replace(/\D/g, '')) || /^#?0+$/.test(ov)) {
            if (tError) tError.classList.add('show');
            return;
          }
          var data = { order: ov, email: email.value.trim() };
          var chip = $('#trackOrderChip'); if (chip) chip.textContent = ov.charAt(0) === '#' ? ov : '#' + ov;
          var go = $('#trackGo'); if (go) go.setAttribute('href', buildUrl(cfg.trackUrl, data));
          if (tEmpty) tEmpty.style.display = 'none';
          if (tError) tError.classList.remove('show');
          if (tFormBox) tFormBox.style.display = 'none';
          if (tResult) tResult.classList.add('show');
          /* DEVELOPER: replace the demo block above with your tracking app's
             lookup. Easiest path: keep the form, and on submit just send the
             customer to buildUrl(cfg.trackUrl, data) (ParcelPanel / AfterShip),
             or fetch your app's status JSON and fill the result fields. */
        }, 950);
      });
      var reset = $('#trackReset');
      if (reset) reset.addEventListener('click', function (e) {
        e.preventDefault();
        if (tResult) tResult.classList.remove('show');
        if (tFormBox) tFormBox.style.display = '';
        if (tEmpty) tEmpty.style.display = '';
        trackForm.reset();
        var first = $('#tkOrder'); if (first) first.focus();
      });
    }

    /* ============================================================
       RETURNS / EXCHANGE GUIDED INLINE FORM — returns section
       ============================================================ */
    var rtStart = $('#rtStartForm');
    if (rtStart) {
      var rtStartBox = $('#rtStartBox'), rtSteps = $('#rtSteps'), rtSuccess = $('#rtSuccess');
      var rtFlowForm = $('#rtFlowForm');

      var params = new URLSearchParams(window.location.search);
      if (params.get('return_started') === 'true') {
        if (rtStartBox) rtStartBox.style.display = 'none';
        if (rtSteps) rtSteps.classList.remove('show');
        if (rtSuccess) rtSuccess.classList.add('show');
        var o = params.get('order') || '';
        var e = params.get('email') || '';
        var chip = $('#rtSuccessChip'); if (chip && o) chip.textContent = o.charAt(0) === '#' ? o : '#' + o;
        var mode = params.get('mode') || 'exchange';
        var label = $('#rtModeLabel'); if (label) label.textContent = mode;
        var rtPortalBtn = $('#rtPortalBtn');
        if (rtPortalBtn && cfg.returnsUrl) {
          rtPortalBtn.href = buildUrl(cfg.returnsUrl, { order: o, email: e });
        }
        setTimeout(function() { scrollToEl(rtSuccess, 120); }, 100);
      }

      rtStart.addEventListener('submit', function (e) {
        e.preventDefault();
        var order = $('#rtOrder'), email = $('#rtEmail'), ok = true;
        var orderVal = order ? order.value.trim() : '';
        ok = validField(order, /^#?[0-9]+$/.test(orderVal)) && ok;
        ok = validField(email, emailOk(email.value)) && ok;
        if (!ok) return;
        var btn = $('.ohub-submit', rtStart); if (btn) btn.classList.add('loading');
        setTimeout(function () {
          if (btn) btn.classList.remove('loading');
          var ov = order.value.trim();
          var ev = email.value.trim();
          var chip = $('#rtOrderChip'); if (chip) chip.textContent = ov.charAt(0) === '#' ? ov : '#' + ov;
          rtStart.setAttribute('data-order', ov);
          rtStart.setAttribute('data-email', ev);
          
          var rtContactEmail = $('#rtContactEmail'); if (rtContactEmail) rtContactEmail.value = ev;
          var rtContactOrder = $('#rtContactOrder'); if (rtContactOrder) rtContactOrder.value = ov;
          
          if (rtStartBox) rtStartBox.style.display = 'none';
          if (rtSteps) rtSteps.classList.add('show');
          scrollToEl(rtSteps, 120);
        }, 850);
      });

      /* show / hide the "new size" field for exchange vs return */
      function syncNewSize() {
        var checked = root.querySelector('input[name="rtMode"]:checked');
        var mode = checked ? checked.value : 'exchange';
        var row = $('#rtNewSizeRow'); if (!row) return;
        var show = mode === 'exchange';
        row.style.display = show ? '' : 'none';
        var sel = $('#rtNewSize'); if (sel) sel.required = show;
      }
      $$('input[name="rtMode"]').forEach(function (r) { r.addEventListener('change', syncNewSize); });
      syncNewSize();

      if (rtFlowForm) {
        rtFlowForm.addEventListener('submit', function (e) {
          var item = $('#rtItem'), cur = $('#rtCurSize'), nw = $('#rtNewSize'), confirm = $('#rtConfirm');
          var checked = root.querySelector('input[name="rtMode"]:checked');
          var mode = checked ? checked.value : 'exchange';
          var ok = true;
          ok = validField(item, !!item.value.trim()) && ok;
          ok = validField(cur, !!cur.value) && ok;
          if (mode === 'exchange') ok = validField(nw, !!nw.value) && ok;
          if (confirm && !confirm.checked) { ok = false; toast('Please confirm the condition to continue'); }
          
          if (!ok) {
            e.preventDefault();
            return;
          }
          var rtContactType = $('#rtContactType');
          if (rtContactType) rtContactType.value = mode === 'exchange' ? 'Exchange' : 'Return';
          
          var orderVal = rtStart.getAttribute('data-order') || '';
          
          function addHidden(name, val) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = val;
            rtFlowForm.appendChild(input);
          }
          
          var emailVal = rtStart.getAttribute('data-email') || '';
          
          var redirectUrl = window.location.pathname + '?return_started=true&order=' + encodeURIComponent(orderVal) + '&email=' + encodeURIComponent(emailVal) + '&mode=' + mode + '#rtSuccess';
          addHidden('return_to', redirectUrl);
          
          // Let the browser submit natively (no e.preventDefault() here)
          setTimeout(function() {
            if (btn) btn.classList.remove('loading');
            toast('Submission is taking too long. Please try again or contact support.');
          }, 10000);
        });
      }
    }

    /* ---------- FAQ accordion ---------- */
    $$('.faq-item').forEach(function (item) {
      var q = $('.faq-q', item), a = $('.faq-a', item);
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        $$('.faq-item.open').forEach(function (other) {
          if (other !== item) { other.classList.remove('open'); var oa = $('.faq-a', other); if (oa) oa.style.maxHeight = '0px'; }
        });
        if (isOpen) { item.classList.remove('open'); a.style.maxHeight = '0px'; }
        else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
    window.addEventListener('resize', function () {
      var open = $('.faq-item.open'); if (open) { var a = $('.faq-a', open); if (a) a.style.maxHeight = a.scrollHeight + 'px'; }
    }, { passive: true });

    /* ---------- Toast ---------- */
    var toastZone = $('#toastZone');
    function toast(msg) {
      if (!toastZone) return;
      var t = document.createElement('div');
      t.className = 'toast';
      t.innerHTML = '<span class="tk"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 6"/></svg></span><span></span>';
      t.lastChild.textContent = msg;
      toastZone.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('show'); });
      setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 400); }, 3200);
    }

    /* ---------- Sticky mobile help button ---------- */
    var sticky = $('#stickyHelp');
    if (sticky) {
      var anchor = $(sticky.getAttribute('data-near') || '#none');
      var onScrollSticky = function () {
        var past = window.scrollY > window.innerHeight * 0.7;
        var near = false;
        if (anchor) { var r = anchor.getBoundingClientRect(); near = r.top < window.innerHeight && r.bottom > 0; }
        sticky.classList.toggle('show', past && !near);
      };
      window.addEventListener('scroll', onScrollSticky, { passive: true });
      onScrollSticky();
    }

    /* ---------- Rain canvas (hero) ---------- */
    (function initRain() {
      var canvas = $('#heroRain');
      if (!canvas || reduce) return;
      var ctx = canvas.getContext('2d');
      var host = canvas.parentElement;
      var W = 0, H = 0, dpr = 1, drops = [], running = false, inView = false;
      var COUNT = 70, COLOR = '150,200,212';
      function resize() {
        dpr = Math.min(2, window.devicePixelRatio || 1);
        var r = host.getBoundingClientRect(); W = r.width; H = r.height;
        canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function seed() {
        drops = [];
        for (var i = 0; i < COUNT; i++) {
          drops.push({ x: Math.random() * W, y: Math.random() * H, len: 9 + Math.random() * 16, v: 6 + Math.random() * 8, a: 0.05 + Math.random() * 0.14 });
        }
      }
      function loop() {
        ctx.clearRect(0, 0, W, H); ctx.lineWidth = 1.1;
        for (var i = 0; i < drops.length; i++) {
          var d = drops[i];
          ctx.strokeStyle = 'rgba(' + COLOR + ',' + d.a + ')';
          ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x - 1.5, d.y + d.len); ctx.stroke();
          d.y += d.v; d.x -= 0.4;
          if (d.y > H) { d.y = -d.len; d.x = Math.random() * W; }
        }
        if (inView) requestAnimationFrame(loop); else running = false;
      }
      function start() { if (!running) { running = true; requestAnimationFrame(loop); } }
      resize(); seed(); inView = true; start();
      window.addEventListener('resize', function () { resize(); seed(); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { inView = e.isIntersecting; if (inView) start(); });
        }, { threshold: 0.02 }).observe(host);
      }
    })();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('.oszea-sp')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme Editor: a section can be re-rendered at any time. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.oszea-sp') : null;
    if (el) { el.__oszeaSpBound = false; init(el); }
  });
})();
